const ftrprfUserRoles = {
  ADMIN: 'FTRPRF_ADMIN',
  SCHOOLADMIN: 'FTRPRF_SCHOOLADMIN',
  SCHOOLSTUDENT: 'FTRPRF_SCHOOLSTUDENT',
  SCHOOLTEACHER: 'FTRPRF_SCHOOLTEACHER',
};

ftrprfUserRoles.FTRPRF_SCHOOLTEACHER = ftrprfUserRoles.SCHOOLTEACHER;
ftrprfUserRoles.FTRPRF_ADMIN = ftrprfUserRoles.ADMIN;
ftrprfUserRoles.FTRPRF_SCHOOLSTUDENT = ftrprfUserRoles.SCHOOLSTUDENT;
ftrprfUserRoles.FTRPRF_SCHOOLADMIN = ftrprfUserRoles.SCHOOLADMIN;

export default ftrprfUserRoles;
